(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["nf-quote-request-link"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('quote-request-link')) {
    customElements.define(
      'quote-request-link',
      class QuoteRequestLink extends HTMLElement {
        connectedCallback() {
          this.button = this.querySelector('[data-quote-request-trigger]');
          this.button?.addEventListener('click', this.#openQuoteRequest.bind(this));
        }

        #openQuoteRequest() {
          const productInfo = this.closest('product-info') || document;
          const quoteButton = productInfo.querySelector('.omgrfq-btn-quotes');

          if (!quoteButton) return;

          quoteButton.click();
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
